<div class="topbar-menu">
  <div class="container-fluid">
    <div id="navigation">
      <!-- Navigation Menu-->
      <ul class="navigation-menu">

        <li class="has-submenu">
          <a [routerLink]="['/']" routerLinkActive="active"><i class="fe-airplay"></i>Dashboard</a>
        </li>

        <li class="has-submenu" *ngIf="canViewSettlement">
          <a [routerLink]="['/settlement']" routerLinkActive="active"><i class="fe-airplay"></i>Settlement</a>
        </li>

        <li class="has-submenu" *ngIf="canViewUsers || canViewRoles || canViewClients || canViewParticipants || canViewTutukaReports">
          <a href="javascript:void(0)">
            <i class="fe-briefcase"></i>Admin
          </a>
          <ul class="submenu">
            <li><a [routerLink]="['/management/users']" routerLinkActive="active" *ngIf="canViewUsers">User Management</a></li>
            <li><a [routerLink]="['/management/roles']" routerLinkActive="active" *ngIf="canViewRoles">Roles Management</a></li>
            <li><a [routerLink]="['/management/client']" routerLinkActive="active" *ngIf="canViewClients">API Integration Management</a></li>
            <li><a [routerLink]="['/management/participant']" routerLinkActive="active" *ngIf="canViewParticipants">Participant Management</a></li>
            <li><a [routerLink]="['/management/report']" routerLinkActive="active" *ngIf="canViewTutukaReports">Report Management</a></li>
            <li><a [routerLink]="['/management/custom-services']" routerLinkActive="active" *ngIf="canViewParticipants">Custom Service Configuration</a></li>
          </ul>
        </li>
        <li class="has-submenu" *ngIf="canViewMerchant || canViewTerminal || canViewMerchantConfig || canViewTerminalConfig">
          <a href="javascript:void(0)">
            <i class="fe-briefcase"></i>Merchant & Terminal Management
          </a>
          <ul class="submenu">
            <li><a [routerLink]="['/management/merchant']" routerLinkActive="active" *ngIf="canViewMerchant">Merchant Management <span *ngIf="merchantCount != null">({{merchantCount}})</span></a></li>
            <li><a [routerLink]="['/management/terminal']" routerLinkActive="active" *ngIf="canViewTerminal">Terminal Management <span *ngIf="terminalCount != null">({{terminalCount}})</span></a></li>
            <li><a [routerLink]="['/management/card-acceptor-config']" routerLinkActive="active" *ngIf="canViewMerchantConfig">Merchant Configuration Management <span *ngIf="merchantConfigCount != null">({{merchantConfigCount}})</span></a></li>
            <li><a [routerLink]="['/management/terminal-config']" routerLinkActive="active" *ngIf="canViewTerminalConfig">Terminal Configuration Management <span *ngIf="terminalConfigCount != null">({{terminalConfigCount}})</span></a></li>
          </ul>
        </li>
        <li class="has-submenu" *ngIf="canViewMerchantAudit || canViewTerminalAudit">
          <a href="javascript:void(0)">
            <i class="fe-activity"></i>Audit Trail
          </a>
          <ul class="submenu">
            <li><a [routerLink]="['/management/audit-merchant']" routerLinkActive="active" *ngIf="canViewMerchantAudit">Merchant Management Audit Trail</a></li>
            <li><a [routerLink]="['/management/audit-terminal']" routerLinkActive="active" *ngIf="canViewTerminalAudit">Terminal Management Audit Trail</a></li>
            <li><a [routerLink]="['/management/audit-merchant-config']" routerLinkActive="active" *ngIf="canViewMerchantConfigAudit">Merchant Configuration Management Audit Trail</a></li>
            <li><a [routerLink]="['/management/audit-terminal-config']" routerLinkActive="active" *ngIf="canViewTerminalConfigAudit">Terminal Configuration Management Audit Trail</a></li>
            <li><a [routerLink]="['/management/audit-user']" routerLinkActive="active" *ngIf="canViewTerminalConfigAudit">User Audit Trail</a></li>
            <li><a [routerLink]="['/management/audit-role']" routerLinkActive="active" *ngIf="canViewTerminalConfigAudit">Roles Audit Trail</a></li>
          </ul>
        </li>
        <li class="has-submenu" *ngIf="canViewReport || canViewGenericReport">
          <a href="javascript:void(0)">
            <i class="fe-book-open"></i>Report
          </a>
          <ul class="submenu">
            <li><a [routerLink]="['/management/report-view']" routerLinkActive="active" *ngIf="canViewReport">Bank Process Report Detail</a></li>
            <li><a [routerLink]="['/management/transaction-report']" routerLinkActive="active" *ngIf="canViewGenericReport">Report Detail</a></li>
          </ul>
        </li>

        <li class="has-submenu" *ngIf="canViewCredit">
          <a href="javascript:void(0)">
            <i class="fe-paperclip"></i>Credit Service
          </a>
          <ul class="submenu">
            <li><a [routerLink]="['/management/credit']" routerLinkActive="active" *ngIf="canViewCredit">Balance Inquiry</a></li>
          </ul>
        </li>

        <li class="has-submenu" *ngIf="canViewMerchantSignUp">
          <a href="javascript:void(0)">
            <i class="fe-paperclip"></i>Merchant Onboarding
          </a>
          <ul class="submenu">
            <li><a [routerLink]="['/management/merchant-sign-up']" routerLinkActive="active" *ngIf="canViewMerchantSignUp">Merchant Sign-Up</a></li>
            <!-- <li><a [routerLink]="['/management/terminal-sign-up']" routerLinkActive="active" *ngIf="canViewMerchantSignUp">Terminal Sign-up</a></li> -->
            <li><a [routerLink]="['/management/terminal-staging']" routerLinkActive="active" *ngIf="canViewMerchantSignUp">ACS Terminal Staging {{ACSTerminalStagingCount}}</a></li>
            <li><a [routerLink]="['/management/terminals-tracking']" routerLinkActive="active" *ngIf="canViewMerchantSignUp">Aramex Terminal Tracking</a></li>
            <li><a [routerLink]="['/management/merchant-terminals-configuration']" routerLinkActive="active" *ngIf="canEditMerchantTerminalConfig">Merchant & Terminal Configurations</a></li>
            <li><a [routerLink]="['/management/dispatch-terminal']" routerLinkActive="active" *ngIf="canViewTerminalDispatched">Dispatch Terminal </a></li>
            <li><a [routerLink]="['/management/archived-terminals-card']" routerLinkActive="active" *ngIf="canViewArchivedTerminals">Archived Tickets</a></li>
            <li><a [routerLink]="['/management/terminal-signup-report']" routerLinkActive="active" *ngIf="canViewTerminalSignUpReport">Report</a></li>
            <li><a [routerLink]="['/management/returned-terminals']" routerLinkActive="active" *ngIf="canViewReturnedTerminals">Returned Devices Reporting</a></li>

          </ul>
        </li>

      </ul>
      <!-- End navigation menu -->

      <div class="clearfix"></div>
    </div>
    <!-- end #navigation -->
  </div>
  <!-- end container -->
</div>
<!-- end navbar-custom -->
